/**
 * Hook para resetear contraseña. Usa authApi (Axios).
 */
import type { ResetPasswordRequest } from "common/models";
import { useMutation, UseMutationResult, UseMutationOptions } from "react-query";
import { authApi } from "../api/authApi";

export function useResetPassword(
    options?: UseMutationOptions<void, unknown, ResetPasswordRequest>
): UseMutationResult<void, unknown, ResetPasswordRequest> {
    return useMutation(
        async (body: ResetPasswordRequest) => {
            await authApi.resetPassword(body);
        },
        options
    );
}
